import { usePrenuvoStore } from '@/stores/usePrenuvoStore';
import { useShallow } from 'zustand/react/shallow';

export const useSkuDetails = () => {
  const { discount, discountType, locationId, marketingReferral, selectedSku, referralCredit } =
    usePrenuvoStore(
      useShallow((state) => ({
        discount: state.payment.discount,
        discountType: state.payment.discountType,
        locationId: state.scan.locationId,
        marketingReferral: state.payment.marketingReferral,
        referralCredit: state.payment.referralCredit,
        selectedSku: state.scan.sku,
      })),
    );

  return { discount, discountType, locationId, marketingReferral, selectedSku, referralCredit };
};
